import React from "react";
import { Skeleton } from "antd";

interface IProps {
    even: boolean;
}

const ActivityListSkeleton: React.FC<IProps> = ({even} : IProps) => {
    return (
        <div className={"activity-list-activity-item " + even ? "even" : "odd"} >
            <Skeleton.Input
                style={{width: '100%', height: '60px', verticalAlign: 'center'}}
                active={true}
                size={"large"}
                block={true} />
        </div>
    );
};
export default ActivityListSkeleton;
